import { useMemo } from 'react'
import { useEnumTranslation, TranslationHandler } from '../useEnumTranslation'
import { AppointmentType as TranslationKey } from 'constants/'
import { makeTranslationProxy } from '../util'

const useAppointmentTypeTranslations = () => {
  const t = useEnumTranslation()

  return useMemo<Record<TranslationKey, TranslationHandler>>(() => {
    const translations: Record<TranslationKey, TranslationHandler> = {
      [TranslationKey.AFTERCARE_FOLLOW_UP]: (options) => t('appointment_types.aftercare_follow_up', options),
      [TranslationKey.EXTENDED_FOLLOW_UP]: (options) => t('appointment_types.extended_follow_up', options),
      [TranslationKey.FINAL_APPOINTMENT]: (options) => t('appointment_types.final_appointment', options),
      [TranslationKey.FOLLOW_UP]: (options) => t('appointment_types.follow_up', options),
      [TranslationKey.HEARING_AID_EVALUATION]: (options) => t('appointment_types.hearing_aid_evaluation', options),
      [TranslationKey.VIDEO_CARE_CALL]: (options) => t('appointment_types.video_care_call', options),
      [TranslationKey.PREP_CALL]: (options) => t('appointment_types.prep_call', options),
      [TranslationKey.ENT_APPOINTMENT]: (options) => t('appointment_types.ent_appointment', options),
    }

    return makeTranslationProxy(translations)
  }, [t])
}

export { useAppointmentTypeTranslations }
